<template>
  <div class="error not-found">
    <h1>404 - Page Not Found</h1>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>
